<script setup>
import { useSnackBar } from '@/utils/stores/snackbar'

const snackbarStore = useSnackBar()

const { snackbarMessage } = storeToRefs(snackbarStore)
</script>

<template>
  <VSnackbar
    v-model="snackbarStore.isShow"
    :timeout="snackbarStore.timeout"
    :color="snackbarStore.color"
    :location="snackbarStore.location"
  >
    {{ snackbarMessage }}
  </VSnackbar>
</template>
